import React, { useEffect, useRef } from "react";
// import { BookingMapWidgetTitle } from "./BookingMapWidgetTitle";
import "./BookingMapWidget.css";
const BookingMapWidget2 = ({ title, bookingMapWidgetFromQuery }) => {
  const widgetRef = useRef(null);

  /**
   *
   * CAUTION! SENSITIVE CODE in useEffect!
   *
   */
  useEffect(() => {
    // Find and extract the script tags from the inner HTML
    const widgetContainer = widgetRef.current;

    if (widgetContainer) {
      const scriptTags = widgetContainer.querySelectorAll("script");

      scriptTags.forEach(oldScriptTag => {
        const newScriptTag = document.createElement("script");
        // Copy the src or the inline script content
        if (oldScriptTag.src) {
          newScriptTag.src = oldScriptTag.src;
        } else {
          newScriptTag.textContent = oldScriptTag.textContent;
        }

        // Append the new script tag to the widget container
        widgetContainer.appendChild(newScriptTag);

        // Optionally, remove the old script tag to avoid duplication
        oldScriptTag.parentNode.removeChild(oldScriptTag);
      });
    }
  }, [bookingMapWidgetFromQuery]);

  return (
    <div id="booking-map-widget" className="paper">
      {/* <BookingMapWidgetTitle bookingMapWidgeTitleHTML={title} /> */}
      <div
        ref={widgetRef}
        dangerouslySetInnerHTML={{ __html: bookingMapWidgetFromQuery }}
      />
    </div>
  );
};

export { BookingMapWidget2 };
